import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import Logo from "./Logo";

const Footer = () => (
  <footer className="mt-20 bg-slate-900 text-slate-300">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-10">
      <div className="md:col-span-2">
        <div className="bg-white inline-block rounded-xl p-3">
          <Logo size="md" />
        </div>
        <p className="mt-4 text-sm leading-relaxed max-w-sm">
          Tu tienda online de productos de limpieza y bazar. Calidad mayorista y minorista para el hogar, comercio e industria.
        </p>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Contacto</h4>
        <ul className="space-y-2 text-sm">
          <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-green-400" /> 11 3327-5841</li>
          <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-blue-400" /> produlimp.bv@gmail.com</li>
          <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-red-400" /> Buenos Aires, Argentina</li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-semibold mb-4">Seguinos</h4>
        <div className="flex gap-3">
          <a href="#" className="p-2 bg-slate-800 rounded-full hover:bg-blue-600 transition-colors" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
          <a href="#" className="p-2 bg-slate-800 rounded-full hover:bg-red-500 transition-colors" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
        </div>
      </div>
    </div>
    <div className="border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 py-5 text-xs text-slate-500 flex justify-between">
        <span>© {new Date().getFullYear()} Produlimp BV. Todos los derechos reservados.</span>
        <span>Hecho en Argentina</span>
      </div>
    </div>
  </footer>
);

export default Footer;
